<template>
  <div class="form-wrap">
    <Row class="detail-title"> {{ detail.caseCode }} - {{ detail.projectName }}</Row>
    <Row v-if="clueDetail" class="detail-header">
      <span>线索</span>
    </Row>
    <Row v-if="clueDetail" class="detail-content">
      <Row>
        <Col>侵权产品</Col>
      </Row>
      <Row>
        <Col>
          <file-upload
            :default-list="clueDetail.attachmentList || []"
            :upload-config="{readOnly:true}"
          />
        </Col>
      </Row>
      <Row>
        <Col span="2" class="textover left-label">侵权方式：</Col>
        <Col span="20" class="textover right-content">{{ clueDetail.tortType == 'E_EC' ? $t("tort_type."+clueDetail.tortType)+'——'+clueDetail.channelTypeZh : $t("tort_type."+clueDetail.tortType) }}</Col>
      </Row>
      <Row>
        <Col span="2" class="textover left-label">评价数：</Col>
        <Col span="20" class="textover right-content">{{ clueDetail.clueProduct&& clueDetail.clueProduct.comment }}</Col>
      </Row>
      <Row>
        <Col span="2" class="textover left-label">销量：</Col>
        <Col span="20" class="textover right-content">{{ clueDetail.clueProduct&& clueDetail.clueProduct.saleNum }}</Col>
      </Row>
      <Row>
        <Col span="2" class="textover left-label">单价：</Col>
        <Col span="20" class="textover right-content">{{ common.formateNumber(clueDetail.clueProduct&&clueDetail.clueProduct.price) }}</Col>
      </Row>
      <Row>
        <Col span="2" class="textover left-label">产品链接：</Col>
        <Col
          span="20" class="textover right-content"
          :title="clueDetail.clueProduct && clueDetail.clueProduct.productUrl"
        >
          <a :href="clueDetail.clueProduct && clueDetail.clueProduct.productUrl" target="_blank">{{ clueDetail.clueProduct && clueDetail.clueProduct.productUrl }}</a>
        </Col>
      </Row>
      <Row>
        <Col span="2" class="textover left-label">调查地址：</Col>
        <Col span="20" class="textover right-content">
          <span :title="(clueDetail.provinceName || '')+(clueDetail.cityName || '')+(clueDetail.areaName || '')+(clueDetail.address || '')">{{ clueDetail.provinceName || "" }}{{ clueDetail.cityName || "" }}{{ clueDetail.areaName || "" }}{{ clueDetail.address || "" }}</span>
        </Col>
      </Row>
    </Row>
    <Row v-if="judgmentData" class="case-content">
      <Row class="detail-header">
        <span>判决</span>
      </Row>
      <Row class="detail-content">
        <Row><Col span="2" class="textover left-label">判决日期：</Col><Col span="20" class="textover right-content">{{ judgmentData.judgmentDate || "" }}</Col></Row>
        <Row><Col span="2" class="textover left-label">签收日期：</Col><Col span="20" class="textover right-content">{{ judgmentData.signDate || "" }}</Col></Row>
        <Row><Col span="2" class="textover left-label"> 判决金额：</Col><Col span="20" class="textover right-content">{{ common.formateNumber(judgmentData.amount || "") }}</Col></Row>
        <Row><Col span="2" class="textover left-label">对方承担诉讼费金额：</Col><Col span="20" class="textover right-content">{{ common.formateNumber(judgmentData.litigantFee || "") }}</Col></Row>
        <Row><Col span="2" class="textover left-label">判决摘录：</Col><Col span="20" class="textover right-content">{{ judgmentData.remark || "" }}</Col></Row>
        <Row>
          <Col span="2" class="textover left-label">判决书：</Col>
          <Col span="20" class="textover right-content">
            <file-upload
              :default-list="judgmentData.attachments || []"
              :upload-config="{readOnly:true}"
            />
          </Col>
        </Row>
        <Row><Col span="2" class="textover left-label">判决结果：</Col><Col span="20" class="textover">{{ judgmentData.result?"胜诉":"败诉" }}</Col></Row>
      </Row>
    </Row>
  </div>
</template>
<script>
import styles from '@/assets/globalStyle.scss'
export default {
  components: {
  },
  props: ['detail'],
  data () {
    return {
      mainColor: styles,
      type: 2,
      clueDetail: null,
      judgmentData: null,
      uploadConfig: {
        readOnly: true
      }
    }
  },
  computed: {
  },
  watch: {

  },
  created() {
    this.getCaseProcess()
    this.getClueDetail()
  },
  beforeMount() {

  },
  mounted() {

  },
  updated() {

  },

  methods: {
  // 获取线索详情
    getClueDetail() {
      const url = '/business/clue/view/' + this.detail.clueId
      this.$get(url).then(res => {
        if (res.code === 0) {
          this.clueDetail = res.data
        }
      })
    },
    // 获取判决详情
    getJudgmentDetail(id) {
      if (!id) return
      const url = '/business/case/judgment?processId=' + id
      this.$get(url).then(res => {
        if (res.code == 0) {
          this.judgmentData = res.data || ''
        }
      })
    },
    // 获取案件进程
    getCaseProcess() {
      const url = '/business/case/process?caseId=' + this.detail.caseId
      this.$get(url).then(res => {
        if (res.code === 0) {
          this.processList = res.data
          let processId = ''
          for (let i = 0; i < this.processList.length; i++) {
            if (this.processList[i].code === 'JT_BB') {
              processId = this.processList[i].processId
            }
          }
          this.getJudgmentDetail(processId)
        }
      })
    }
  }
}
</script>
  <style lang="scss" scoped>
  @import '@/assets/globalStyle.scss';
  .form-wrap {
  padding: 20px;
  .detail-title {
    font-size: 16px;
    margin-bottom: 12px;
    padding-left: 40px;
  }
  .detail-content{
    padding-left: 40px;
    >div{
      line-height: 25px;
    }
  }
}
  </style>




// WEBPACK FOOTER //
// src/view/carryoutMaterialManage/components/casePlanForm.vue